import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, FilterService, MenuItem, MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { Lang } from 'src/app/domain/models/Language';
import { BasicUser } from 'src/app/domain/models/User';
import { ErrorMessageUtil } from 'src/app/ui/util/error-message-util';
import { Country, NewCountry } from 'src/app/domain/models/Country';
import { CountryGateway } from 'src/app/application/gateway/CountryGateway';

@Component({
  selector: 'app-admin-manage-countries',
  templateUrl: './admin-manage-countries.component.html',
  styleUrls: ['./admin-manage-countries.component.css'],
  providers: [ConfirmationService]
})
export class AdminManageCountriesComponent implements OnInit{
  breadcrumbHome: MenuItem = {}
  countries: Country[] = []
  loading: boolean = false
  submit: boolean = false
  profile: BasicUser | undefined
  langs: Lang[] = []
  lang: Lang | undefined

  totalCount = 0;
  pageSize = 5;

  formGroup: FormGroup = this._formBuilder.group({
    name: ['', Validators.required],
    namees: ['', Validators.required],
    code: ['', Validators.required]
  })

  isSectionLoaded: boolean = false;
  fragmentToScroll: string | null = null;

  constructor(private _router: Router,
    private _formBuilder: FormBuilder,
    private _authService: AuthGateway,
    private _messageService: MessageService,
    public translate: TranslateService,
    private _countryService: CountryGateway
  ){
  }

  ngOnInit(): void {
    this.profile = this._authService.getUser()
    if (this.profile) {
      this.translate.use(this.profile.lang)
    }
    this.loadBreadcrumb();
    this.formGroup.get('code')?.valueChanges.subscribe((value: string) => {
      if (value) {
      this.formGroup.get('code')?.setValue(value.toUpperCase(), { emitEvent: false });
      }
    });
  }

  getCountriesPaged(event: any)
  {
      const pageNumber = Math.floor(event.first / event.rows) + 1;
      const pageSize = event.rows;

      this.getCountries(pageSize, pageNumber);
  }

  getCountries(pageSize: number = this.pageSize, pageNumber: number = 1) {
    this.loading = true;
    const profile = this._authService.getUser();

    this._countryService.getAllPaged(pageNumber, pageSize).subscribe({
      next: (v) => {
        this.countries = v.items

        this.totalCount = v.totalCount;

        this.loading = false;
      },
      error: (e) => {
        console.log(e)
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.Country.ManyRetrieveError') })
      }
    })
  }

  submitForm() {
    this.loading = true
    if (this.formGroup.valid) {
      let request = null;
      const newCountry: NewCountry = {
        name: this.formGroup.controls["name"].value,
        nameEs: this.formGroup.controls["namees"].value,
        code: this.formGroup.controls["code"].value
      }

      this._countryService.create(newCountry).subscribe({
        next: () => {
          this.formGroup.reset()
          this.submit = false
          this.loading = false
          this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('MessageService.Country.CreateSuccess') })
        },
        error: (e) => {
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.Country.CreateError') });
        }
      })
    }
    else {
      this.loading = false
    }
  }


  loadBreadcrumb() {
    this.translate.get([
      'CountriesPage.PageHomeTitle',
    ]).subscribe({
      next: (tranlations) => {
        this.breadcrumbHome = {
          label: tranlations['CountriesPage.PageHomeTitle']
        }
      },
      error: () => {}
    })
  }

  getErrorMessage(fieldName: string): string {
    return ErrorMessageUtil.getErrorMessage(this.formGroup, this.translate, fieldName)
  }

  get placeholder(): string {
    return this.translate.instant('SwitchLangComponent.SwitchLangComponentPlaceholder')
  }

  showLanguage(language: string): string | undefined {
    return this.langs.find(x => x.lang == language)?.label
  }

  ngOnDestroy(): void {
    document.documentElement.style.scrollBehavior = 'auto';
  }
}
